//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CommonCard from "../CommonCard";
import DateSwitch from "../DateSwitch";
import { mapState } from "vuex";

export default {
  components: { CommonCard, DateSwitch },
  data() {
    return {
      options: {},
      active: 2,
    };
  },
  computed: {
    ...mapState(["dateList"]),
  },
  mounted() {
    this.options = {
      color: ["#EE4E40", "#01AFD2", "#847BE6", "#F29202"],
      title: {
        text: "费用占比：",
        textStyle: {
          color: "#3A3737",
          fontSize: 14,
        },
        top: 0,
        left: "55%",
      },
      grid: {
        top: 0,
        left: 0,
        bottom: 0,
      },
      legend: {
        type: "scroll",
        orient: "vertical",
        left: "55%",
        top: 25,
        bottom: 20,
        height: "75%",
        data: ["A类", "B类", "C类", "D类"],
        textStyle: {
          color: "#999999",
        },
      },
      series: [
        {
          name: "各类费用占比",
          type: "pie",
          center: ["30%", "50%"],
          radius: "88%",
          data: [
            { name: "A类", value: 45 },
            { name: "B类", value: 20 },
            { name: "C类", value: 20 },
            { name: "D类", value: 15 },
          ],
          label: {
            position: "inside",
            formatter: "{d}%",
            fontSize: 18,
            color: "#fff",
          },
          emphasis: {
            show: false,
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
      ],
    };
  },
};
